import { Component, OnInit } from '@angular/core';
import { SitemapService } from '../../../services/sitemap.service';

@Component({
  selector: 'app-sitemap-generator',
  templateUrl: './sitemap-generator.component.html',
  styleUrls: ['./sitemap-generator.component.scss']
})
export class SitemapGeneratorComponent implements OnInit {
  sitemapContent: string = '';
  isLoading: boolean = false;
  error: string = '';

  constructor(private sitemapService: SitemapService) { }

  ngOnInit(): void {
    this.generateSitemap();
  }

  generateSitemap(): void {
    this.isLoading = true;
    this.error = '';
    
    this.sitemapService.generateSitemap().subscribe({
      next: (sitemap) => {
        this.sitemapContent = sitemap;
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Error generating sitemap: ' + err.message;
        this.isLoading = false;
      }
    });
  }

  downloadSitemap(): void {
    const blob = new Blob([this.sitemapContent], { type: 'application/xml' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sitemap.xml';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
} 